import { create } from 'zustand'
import type { User, AuthTokens } from '@/types/auth'

interface AuthState {
  user: User | null
  tokens: AuthTokens | null
  isAuthenticated: boolean
  isLoading: boolean
  setAuth: (user: User, tokens: AuthTokens) => void
  clearAuth: () => void
  setLoading: (v: boolean) => void
}

function loadTokens(): AuthTokens | null {
  try {
    const raw = localStorage.getItem('tembo_tokens')
    return raw ? JSON.parse(raw) : null
  } catch {
    return null
  }
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  tokens: loadTokens(),
  isAuthenticated: false,
  isLoading: true,

  setAuth: (user, tokens) => {
    localStorage.setItem('tembo_tokens', JSON.stringify(tokens))
    set({ user, tokens, isAuthenticated: true, isLoading: false })
  },

  clearAuth: () => {
    localStorage.removeItem('tembo_tokens')
    set({ user: null, tokens: null, isAuthenticated: false, isLoading: false })
  },

  setLoading: (v) => set({ isLoading: v }),
}))
